import { FC } from 'react'
import { BodyContent, LayoutContainer, LayoutMainContent, LayoutMainInner, LayoutRightContent, LayoutBackground } from './layout.styled'
import { LayoutProps } from './layout.types'


export const Layout: FC<LayoutProps> = ({ children, rightContent }) => (
  <LayoutBackground>
    <LayoutContainer>
      <LayoutMainContent>
        <LayoutMainInner>
          <BodyContent>
            {children}
          </BodyContent>
        </LayoutMainInner>
      </LayoutMainContent>
      <LayoutRightContent>
        {rightContent}
      </LayoutRightContent>
    </LayoutContainer>
  </LayoutBackground>
)
